import { render, staticRenderFns } from "./CompareSelfieDialog.vue?vue&type=template&id=c670ac9c&scoped=true"
import script from "./CompareSelfieDialog.vue?vue&type=script&lang=js"
export * from "./CompareSelfieDialog.vue?vue&type=script&lang=js"
import style0 from "./CompareSelfieDialog.vue?vue&type=style&index=0&id=c670ac9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c670ac9c",
  null
  
)

export default component.exports